import request from '@/utils/axios'


//公告
export function announceInfo(form) {
    return request({
        url: '/message/newsList',
        method: 'get',
        params: form
    })
}

//用户站内信数量
export function userMessageCount(form) {
    return request({
        url: '/message/countMessage',
        method: 'get',
        params: form
    })
}

//用户站内信
export function userMessageInfo(form) {
    return request({
        url: '/message/messageList',
        method: 'get',
        params: form
    })
}

//已读站内信
export function hadReadMessage(form) {
    return request({
        url: '/message/readMessage',
        method: 'get',
        params: form
    })
}

//反馈意见提交
export function sendFeedback(form) {
    return request({
        url: '/message/submitOpinion',
        method: 'get',
        params: form
    })
}


// WEBPACK FOOTER //
// ./src/api/message.js